module.exports = __webpack_public_path__ + "media/images/svg/avant_garde-ffe0acd93b2f6619864d6a9e68f6d7a3.svg";